import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 51px;
  border-radius: 2px;
  overflow: hidden;
`;

interface TabProps {
    flexGrow: number;
    isActive: boolean;
    disabled?: boolean;
}

export const Tab = styled.button<TabProps>`
    flex: ${({ flexGrow }) => `${flexGrow} 1 0`};
    min-width: 0;
    height: 51px;
    cursor: pointer;
    font-family: "Baloo 2", sans-serif;
    font-weight: 600;
    font-size: 18px;
    color: #ffffff;
    transition: all 0.2s ease;
    border: 2px solid transparent;
    text-transform: uppercase;
    white-space: nowrap;
    padding: 0 16px;
    box-sizing: border-box;

  ${({ isActive }) =>
        isActive
            ? css`
          background-color: #e71037;
          border: 2px solid #FFFFFF;
        `
            : css`
          background-color: #f57e38;
        `}

  ${({ disabled }) =>
        disabled &&
        css`
        cursor: not-allowed;
    `}

  &:hover:not(:disabled) {
      background-color: #fff;
      color: #e71037;
      cursor: pointer;
      transition: 500ms;
  }
`;
